import React from 'react';
import { MaskedLines, Reveal } from './reveal';

/**
 * SectionHead — animated section heading.
 *
 * Backward compatible: pass `title` (string or JSX) and it renders as a
 * single masked reveal line. Pass `titleLines={[…]}` to stagger a
 * multi-line masked reveal; accent-colored words should live on their
 * own entry in the array as <span className="text-cyan-300">…</span>.
 */
export default function SectionHead({ eyebrow, title, titleLines, body }) {
  const lines = titleLines || (title != null ? [title] : []);
  return (
    <div className="max-w-3xl">
      <Reveal className="flex items-center gap-3 mb-3 sm:mb-4" y={12}>
        <span className="h-px w-8 sm:w-10 bg-cyan-400" />
        <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em]">
          {eyebrow}
        </span>
      </Reveal>
      <h2 className="font-display text-white text-2xl sm:text-3xl md:text-4xl lg:text-[2.6rem] font-bold uppercase leading-[1.05] sm:leading-[1.02] tracking-tight">
        <MaskedLines lines={lines} />
      </h2>
      {body && (
        <Reveal delay={0.15} y={16}>
          <p className="mt-4 sm:mt-5 text-zinc-400 text-sm sm:text-base md:text-lg max-w-2xl">
            {body}
          </p>
        </Reveal>
      )}
    </div>
  );
}
